import React, { PureComponent } from 'react'
import styled from 'styled-components'
import { styles } from 'gipsy-misc'

import { headerPaddingStyle } from 'features/list/styles'

class TagFilters extends PureComponent {
  state = {
    selectedFilterId: 'all'
  }

  onClick = (tag, isSelected) => {
    if (isSelected) {
      return
    }

    if (this.props.onSelectFilter) {
      this.props.onSelectFilter(tag.id)
    }

    this.setState({
      selectedFilterId: tag.id
    })
  }

  render() {
    const { tags } = this.props
    const { selectedFilterId } = this.state

    let filters = [
      { id: 'all', name: 'All', color: styles.colors.veryLightGrey, backgroundColor: styles.colors.darkGrey }
    ]
    if (tags) {
      filters = filters.concat(tags)
    }

    return (
      <Container>
        {filters.map(tag => {
          const isSelected = selectedFilterId === tag.id
          return (
            <Filter
              key={tag.id}
              isSelected={isSelected}
              color={tag.color}
              backgroundColor={tag.backgroundColor}
              onClick={() => this.onClick(tag, isSelected)}>
              {tag.name}
            </Filter>
          )
        })}
      </Container>
    )
  }
}

const Container = styled.div`
  ${headerPaddingStyle}
  margin-bottom: 26px;
  display: flex;
  flex-wrap: wrap;
`

const Filter = styled.span`
  border-radius: 10px;
  color: ${props => (props.isSelected ? props.color : '')};
  background-color: ${props => (props.isSelected ? props.backgroundColor : styles.colors.lightGrey)};
  padding: 4px 12px;
  margin-right: 4px;
  margin-bottom: 5px;
  font-size: 12px;
  cursor: pointer;
  :hover {
    color: ${props => props.color};
    background-color: ${props => props.backgroundColor};
  }
`

export default TagFilters



// WEBPACK FOOTER //
// ./src/features/todolist/components/tagFilters/index.js